import { createSlice } from "@reduxjs/toolkit";

type OperationState = "DRAFT" | "REVIEW" | "SUMMARY" | "DETAILS";

interface InitialState {
  openModal: boolean;
  operationState: OperationState;
  operationID: string | null;
  data: {
    account: string;
    side: string;
    operationValueArs: string;
    operationValueMep: string;
    isTotal: boolean;
    isResident: boolean;
    createdAt: string;
    executedAt: string;
    state: string;
    isDetailsView: boolean;
    estimatedPrice: string;
    settlementDate: string;
  } | null;
}

const initialState: InitialState = {
  openModal: false,
  operationState: "DRAFT",
  operationID: null,
  data: null,
};

const operationMEPDataSlice = createSlice({
  name: "operationMEPData",
  initialState,
  reducers: {
    updateOperationMEPData: (state, action) => {
      state.data = action.payload;
    },
    openOperationMEPModal: (state) => {
      state.openModal = true;
    },
    updateOperationMEPModal: (state, action) => {
      state.operationState = action.payload;
    },
    closeOperationMEPModal: (state) => {
      state.openModal = false;
      state.operationState = "DRAFT";
    },
    resetOperationMEPModal: (state) => {
      state.openModal = initialState.openModal;
      state.operationState = initialState.operationState;
      state.operationID = initialState.operationID;
      state.data = initialState.data;
    },
    updateOperationMEPID: (state, action) => {
      state.operationID = action.payload;
    },
  },
});

export const {
  updateOperationMEPData,
  openOperationMEPModal,
  updateOperationMEPModal,
  closeOperationMEPModal,
  resetOperationMEPModal,
  updateOperationMEPID,
} = operationMEPDataSlice.actions;
export default operationMEPDataSlice.reducer;
